import { createReduxStore } from "@omni/components/redux/store";
import * as FeatureToggleService from "@omni/components/services/featureToggle/featureToggles.service";
import * as HooksService from "@omni/components/services/hooks.services";
import * as MockDateService from "@omni/components/services/mockDate.service";
import { removeRecentlyViewed } from "@omni/components/services/recentlyViewedProducts.service";
import * as SearchService from "@omni/components/services/search.services";
import { ConfigProvider } from "@omni/config";
import { ConfigType } from "@omni/types/enums/configType.enum";

import Hydrator from "./hydrator";
import "./version.generated";

import "@/styles/index.css";
import "@/styles/index.scss";
import { hasWindow } from "@omni/utils/dom.utils";

export const bootstrap = async () => {
    ConfigProvider.setProvider(ConfigType.Components, () => ({
        ...window.config,
        general: {
            ...window.config.general,
            author: hasWindow() && !!window?.Granite?.author
        }
    }));

    if (!window.storeManager) {
        const store = createReduxStore();
        window.storeManager = store;

        const initialStateModule = await import(
            /* webpackMode: "eager" */ "@omni/components/redux/initialState"
        );
        initialStateModule.resolveInitialState(store);
    }

    const analyticsModule = await import(
        /* webpackMode: "eager" */ "@omni/components/utils/analytics"
    );
    analyticsModule.initializeAnalytics();

    const hydrator = new Hydrator(window.storeManager);
    window.hydrator = hydrator;
    window.clearRecentlyViewed = removeRecentlyViewed;

    if (self !== top) {
        window.parent.hydrator = hydrator;
    }

    FeatureToggleService.init();
    SearchService.init();
    HooksService.init();
    MockDateService.init();

    import(/* webpackMode: "eager" */ "./PureAEMComponents").then((mod) =>
        mod.init()
    );
};
